export default __webpack_public_path__ + "static/media/urgent.b02854c1.svg";